"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
const formQuestionsToFormWithTree_1 = __importDefault(require("@opsbase/lib-form/convert/formQuestionsToFormWithTree"));
const getPercentCompletion_1 = __importDefault(require("@opsbase/lib-form/helpers/getPercentCompletion"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const PerformController_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const web_opform_perform_1 = __importDefault(require("@opsbase/web-opform-perform"));
const OpPerformHeader_1 = __importDefault(require("@opsbase/web-opform-perform/OpPerformHeader"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const dbToFormQuestions_1 = __importDefault(require("../helpers/dbToFormQuestions"));
const makeMyClasses = highlightSelected => ({
    dots: {
        width: 'fit-content',
        margin: '40px auto',
    },
    perform: {
    // zoom: 0.75,
    },
    footer: {
        boxShadow: `0 0 24px -4px ${lib_palette_1.default.BlackCoral.main}`,
        zIndex: 1,
    },
    clearIcon: {
        border: `4px solid white`,
        height: 48,
        borderRadius: 24,
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 0,
    },
    header: {
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
    },
    '& .selectedQuestion': highlightSelected
        ? {
            boxShadow: `0 0 8px -2px ${lib_palette_1.default.secondary.dark} !important`,
        }
        : undefined,
});
exports.Preview = react_1.default.memo((props) => {
    const { highlightSelected = false, footNote } = props;
    const db = (0, useFedDB_1.default)();
    const { selected } = (0, useFedSelect_1.default)();
    const { id, isScoreEnabled, isScorePublic, isGradingPublic, gradingMethod, title, allowIssuesAndNotes, } = (0, useFedSetup_1.default)();
    const { doSelect, doReset } = (0, useFedActions_1.default)();
    const [form, setForm] = (0, react_1.useState)();
    const [percComplete, setPercComplete] = (0, react_1.useState)(0);
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses, [highlightSelected]);
    const _doInitOp = (0, react_1.useMemo)(() => () => {
        setPercComplete(0);
        setIsSubmitted(false);
        setForm((0, formQuestionsToFormWithTree_1.default)((0, dbToFormQuestions_1.default)(db)));
    }, [db]);
    (0, react_1.useEffect)(() => {
        _doInitOp();
    }, [_doInitOp]);
    const handleClear = (0, react_1.useCallback)(() => {
        doReset();
        _doInitOp();
    }, [doReset, _doInitOp]);
    const handleUpdate = (0, react_1.useCallback)(f => {
        setPercComplete((0, getPercentCompletion_1.default)(f));
    }, []);
    const handleChangeSelectedQuestionId = (0, react_1.useCallback)(qId => {
        doSelect(qId);
    }, [doSelect]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise(resolve => {
            setTimeout(() => resolve(setIsSubmitted(true)), 2400);
        });
    }), []);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !form && react_1.default.createElement(Dots_1.default, { className: myCss.dots, color: lib_palette_1.default.primary }),
            !!form && (react_1.default.createElement(PerformController_1.default, { id: id, title: title, placeId: 'some_place_id', placeTitle: 'Somewhere', form: form, isSubmitted: isSubmitted, isScorePublic: isScorePublic, isScoreEnabled: isScoreEnabled, isGradingPublic: isGradingPublic, allowIssuesAndNotes: allowIssuesAndNotes, gradingMethod: gradingMethod, onSubmit: handleSubmit, onUpdate: handleUpdate, selectedQuestionId: selected, onChangeSelectedQuestionId: handleChangeSelectedQuestionId, alwaysShowScoreWhenEnabled: true, isPreview: true },
                react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.perform } },
                    react_1.default.createElement(Pane_1.default, { grow: true },
                        react_1.default.createElement(web_opform_perform_1.default, { highlightSelected: highlightSelected, header: react_1.default.createElement(OpPerformHeader_1.default, { submitButton: react_1.default.createElement(Button_1.default, { classes: { root: myCss.clearIcon }, label: lib_i18n_1.default.t('reset'), tooltip: lib_i18n_1.default.t('clear-preview'), onClick: handleClear, color: lib_palette_1.default.GreyBlue }), submitMessage: lib_i18n_1.default.t('submit-op-preview-text') }, !isSubmitted && percComplete !== 100 && (react_1.default.createElement(Horizontal_1.default, { padding: true, centered: true, classes: { root: myCss.header } },
                                react_1.default.createElement(Pane_1.default, { grow: true },
                                    react_1.default.createElement(Text_1.default, { withBreaks: true, variant: "h2" }, lib_i18n_1.default.t('preview-description'))),
                                react_1.default.createElement(Button_1.default, { classes: { root: myCss.clearIcon }, label: lib_i18n_1.default.t('reset'), tooltip: lib_i18n_1.default.t('clear-preview'), onClick: handleClear, color: lib_palette_1.default.GreyBlue })))) })),
                    !!footNote && footNote)))));
    }, [
        form,
        myCss,
        id,
        title,
        isSubmitted,
        isScorePublic,
        isScoreEnabled,
        isGradingPublic,
        allowIssuesAndNotes,
        gradingMethod,
        handleSubmit,
        handleUpdate,
        selected,
        handleChangeSelectedQuestionId,
        highlightSelected,
        handleClear,
        percComplete,
        footNote,
    ]);
});
exports.default = exports.Preview;
